<template>
    <div class="row">
        <div class="col text-center">
            <div class="sau-bx bx-pad clearfix">
                <div class="row">
                    <div class="col">
                        <h4>Registrar Lock ({{ domain.lock }})</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p>Registrar (or domain) lock can be set in order to prevent unauthorized, unwanted or accidental changes to the domain name.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <button v-if="canUpdateDomain" @click.prevent="updateLockStatus()" 
                        :class="[domain.lock == 'unlocked' ? 'btn-danger' : 'btn-success', 'btn bt-lg  mx-auto']" :disabled="submitting">
                        {{ domain.lock == 'unlocked' ? 'Lock' : 'Unlock' }} Domain <i v-if="submitting" class="far fa-spinner-third fa-spin"></i></button>
                        <p v-else>This functionality is not available on cancelled domains</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['domain'],
        data() {
            return {
                submitting: false,
                lock: ''
            };
        },
        mounted() {
            this.lock = this.domain.lock;
        },
        methods: {
            updateLockStatus() {
                this.submitting = true;
                this.updateDomainLockStatus().then(response => {
                    console.log(response);
                    if(response.data.status === 'success') {
                        if(response.data.data !== null) {
                            this.$swal({
                                type:'error',
                                title: 'Failed to update registrar lock',
                                html: `We were unable to update the lock status of this domain.<br> ${(response.data.data.message || '')} - ${(response.data.data.error)}`,
                                showConfirmButton: true,
                                confirmButtonClass: 'btn btn-danger',
                                buttonsStyling: false,
                            });

                        } else {
                            this.$swal({
                                type:'success',
                                title: 'Registrar Lock Updated',
                                showConfirmButton: false,
                                timer: 3000
                            });

                            this.domain.lock == 'unlocked' ? this.domain.lock = 'locked' : this.domain.lock = 'unlocked';
                        }

                    } else {
                        this.$swal({
                            type:'error',
                            title: 'Failed to update registrar lock',
                            html: response.data.message,
                            showConfirmButton: true,
                            confirmButtonClass: 'btn btn-danger',
                            buttonsStyling: false,
                        });

                    }

                    this.submitting = false;
                })
            },
        },
    }
</script>